module.exports = __webpack_public_path__ + "img/sidebar-logo.826bf2e7.svg";